import { StepInstance } from '../step-instance';
import { StepSubmissionExam } from './step-submission-exam';

export declare class StepExamInstance extends StepInstance {
  public submissions: StepSubmissionExam[];
}
